import { render } from "./Subheader.vue?vue&type=template&id=82e84136&scoped=true"
import script from "./Subheader.vue?vue&type=script&lang=js"
export * from "./Subheader.vue?vue&type=script&lang=js"

import "./Subheader.vue?vue&type=style&index=0&id=82e84136&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82e84136"]])

export default __exports__